import { CurrenciesContext } from 'contexts/providers/CurrenciesProvider'
import { useContext } from 'react'

export function useCurrencies() {
  return useContext(CurrenciesContext)
}
